<template>
  <section class="menu">
    <a class="button line" href="https://api.ncovjp.com/api/line-notify/subscribe" target="_blank">
      <Icon class="icon" type="logo-line" /> {{ $t('message.subscribe_update') }}
    </a>
    <div class="button share" @click="showShareMenu = true">
      <Icon class="icon" type="share" /> {{ $t('message.share_app') }}
    </div>
    <FullScreenMenu
      :title="$t('message.share_app')"
      :show="showShareMenu"
      :options="shareTargets"
      @select="share"
      @close="showShareMenu = false"
      />
  </section>
</template>

<script>
import querystring from 'querystring'
import Icon from '@/components/Icon'
import FullScreenMenu from '@/components/FullScreenMenu'

const SHARE_URI = 'https://ncovjp.com'
const TWITTER_OPTIONS = {
  text: '「都道府県別新型コロナウイルス感染者数マップ」 - 2019-nCoV Japan Case',
  url: SHARE_URI,
  hashtags: '新型コロナウイルス,nCoV,COVID19,Japan',
}

const SHARE_TARGETS = [
  { name: 'Facebook', value: `https://www.facebook.com/sharer/sharer.php?u=${SHARE_URI}` },
  { name: 'Twitter', value: `https://twitter.com/share?${querystring.stringify(TWITTER_OPTIONS)}` },
  { name: 'Line', value: `https://social-plugins.line.me/lineit/share?url=${SHARE_URI}` },
]

export default {
  name: 'Menu',
  data () {
    return {
      showShareMenu: false,
      shareTargets: SHARE_TARGETS,
    }
  },
  methods: {
    share (uri) {
      window.location.href = uri
      this.showShareMenu = false
    },
  },
  components: {
    Icon,
    FullScreenMenu,
  },
}
</script>

<style lang="less" scoped>
.menu {
  z-index: 10;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 320px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  padding: 12px 12px 16px;
  .button {
    font-size: 12px;
    font-weight: bold;
    background-color: #fff;
    padding: 0.5em 1em;
    max-width: 110px;
    width: 100%;
    border-radius: 4px;
    line-height: 2em;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    .icon {
      font-weight: normal;
      padding-right: 8px;
    }
    &.share {
      background-color: hsl(0,0%,100%);
      box-shadow: 0 4px 0 hsl(120,100%,28%);
      border: 1px solid hsl(120,100%,28%);
      color: hsl(120,100%,38%);
      .icon {
        font-size: 16px;
      }
    }
    &.line {
      background-color: hsl(120,100%,38%);
      box-shadow: 0 4px 0 hsl(120,100%,28%);
      border: 1px solid hsl(120,100%,38%);
      color: #fff;
      .icon {
        font-size: 24px;
      }
    }
  }
}
</style>
